











import Vue from "vue";
import Navigation from "@/components/navigation/Navigation.vue";
import Footer from "@/components/shared/footer/Footer.vue";
import ModalPopup from "@/components/shared/modal-popup/ModalPopup.vue";
import JobModalPopup from "@/components/careers-view/job-modal-popup/JobModalPopup.vue";
import FlyerModalPopup from "@/components/shared/flyer-modal-popup/FlyerModalPopup.vue";

export default Vue.extend({
  name: "App",
  components: {
    Navigation,
    Footer,
    ModalPopup,
    JobModalPopup,
    FlyerModalPopup
  }
});
